type Props = {
  color?: string;
};

export default function FilterIcon({
  color = "var(--brand-primary-color)",
}: Props) {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 3H18.5" stroke={color} strokeWidth="2" fill={color} />
      <path d="M0 9H18.5" stroke={color} strokeWidth="2" fill={color} />
      <path d="M0 15H18.5" stroke={color} strokeWidth="2" fill={color} />
      <circle cx="7" cy="3" r="2" fill="white" stroke={color} strokeWidth="2" />
      <circle
        cx="14"
        cy="9"
        r="2"
        fill="white"
        stroke={color}
        strokeWidth="2"
      />
      <circle
        cx="9"
        cy="15"
        r="2"
        fill="white"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}
